import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      id: 1,
      question: 'What are your delivery hours?',
      answer: 'We deliver daily from 8:00 AM to 10:00 PM. Orders placed after 9:30 PM will be delivered the next day.'
    },
    {
      id: 2,
      question: 'How can I place an order?',
      answer: 'You can order through WhatsApp (+211 911 027 181), call us directly, or use our website order form. WhatsApp is the fastest method!'
    },
    {
      id: 3,
      question: 'What payment methods do you accept?',
      answer: 'We accept cash on delivery, mobile money (M-Pesa, Airtel Money), and bank transfers. Payment is required upon delivery.'
    },
    {
      id: 4,
      question: 'Do you offer catering services?',
      answer: 'Yes! We provide catering for events, parties, and corporate functions. Contact us at least 24 hours in advance for large orders.'
    },
    {
      id: 5,
      question: 'What is your minimum order amount?',
      answer: 'Our minimum order is 1,000 SSP for delivery. There is no minimum for pickup orders at our location.'
    },
    {
      id: 6,
      question: 'Can I customize my order?',
      answer: 'Absolutely! We accommodate special requests and dietary preferences. Just let us know when placing your order.'
    },
    {
      id: 7,
      question: 'How long does delivery take?',
      answer: 'Delivery times vary by zone: Central Juba (20-30 mins), East/West (30-40 mins), North (40-50 mins). We always aim to deliver hot and fresh!'
    },
    {
      id: 8,
      question: 'Do you have vegetarian options?',
      answer: 'Yes, we offer several vegetarian chapati options with fresh vegetables, beans, and cheese. Check our menu for full details.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-8 md:py-12 lg:py-16 bg-muted/30">
      <div className="max-w-4xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3 md:mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-muted-foreground">
            Quick answers to common questions about our service
          </p>
        </div>

        <div className="space-y-3 md:space-y-4">
          {faqs?.map((faq, index) => (
            <div
              key={faq?.id}
              className="bg-card border border-border rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-4 md:px-6 py-4 md:py-5 flex items-center justify-between gap-4 text-left hover:bg-muted/50 transition-colors duration-200"
              >
                <span className="font-semibold text-foreground text-sm md:text-base lg:text-lg pr-4">
                  {faq?.question}
                </span>
                <div className={`flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <Icon name="ChevronDown" size={20} color="var(--color-primary)" />
                </div>
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-4 md:px-6 pb-4 md:pb-5 pt-2">
                  <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                    {faq?.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 md:mt-12 text-center p-6 md:p-8 bg-card border border-border rounded-2xl">
          <Icon name="HelpCircle" size={40} color="var(--color-primary)" className="mx-auto mb-4" />
          <h3 className="text-xl md:text-2xl font-bold text-foreground mb-2">
            Still Have Questions?
          </h3>
          <p className="text-sm md:text-base text-muted-foreground mb-4">
            Our team is here to help! Reach out through any of our contact methods.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button
              onClick={() => window.open('https://wa.me/211123456789?text=Hello%20Chapati%20Plus!%20I%20have%20a%20question.', '_blank')}
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-accent hover:bg-accent/90 text-white rounded-lg font-medium transition-colors duration-200"
            >
              <Icon name="MessageCircle" size={20} />
              <span>WhatsApp Us</span>
            </button>
            <button
              onClick={() => window.open('tel:+211123456789', '_self')}
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary hover:bg-primary/90 text-white rounded-lg font-medium transition-colors duration-200"
            >
              <Icon name="Phone" size={20} />
              <span>Call Us</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;